module.exports = __webpack_public_path__ + "static/IMG_0084-69547550687b52995a7e2562f8a868c5.jpg";